import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import Paging from "../../activeusers/components/ActiveUserPaging";
import ChangeLotStatusModal from "./ChangeLotStatusModal";

function formatDateTime(dt) {
  if (!dt) return "Нет данных";
  return new Date(dt).toLocaleString("ru-RU", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Asia/Almaty",
  });
}

const LotStatusTable = ({
  data,
  loading,
  error,
  total,
  page,
  pageLimit,
  onPageChange,
  onChanged,
}) => {
  const rowsPerPage = pageLimit || 10;
  const totalPages = Math.max(1, Math.ceil((total || 0) / rowsPerPage));

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  const handleRowClick = (item) => {
    setSelectedId(item.id);
    setSelectedType(item.lotStatusType);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedId(null);
    setSelectedType(null);
  };

  const handleSuccess = () => {
    onChanged?.();
  };

  // ⬇️ модалка теперь всегда в дереве — рендерим её независимо от loading/error,
  // чтобы reload() не размонтировал открытый диалог
  return (
    <Box>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">Ошибка: {error}</Typography>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Typography variant="h6" gutterBottom>
              Всего статусов: {total || 0}
            </Typography>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Id</TableCell>
                  <TableCell>Code</TableCell>
                  <TableCell>Название</TableCell>
                  <TableCell>Тип статуса</TableCell>
                  <TableCell>Дата создания</TableCell>
                  {/* <TableCell>Активен (лот)</TableCell>
                  <TableCell>Активен (статус)</TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length ? (
                  data.map((item, index) => (
                    <TableRow
                      key={item.id}
                      hover
                      onClick={() => handleRowClick(item)}
                      sx={{ cursor: "pointer" }}
                    >
                      <TableCell>
                        {(page - 1) * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.code ?? "—"}</TableCell>
                      <TableCell>{item.name || "Нет данных"}</TableCell>
                      <TableCell>
                        {item.lotStatusType || "Нет данных"}
                      </TableCell>
                      <TableCell>
                        {formatDateTime(item.dateOfCreation)}
                      </TableCell>
                      {/* <TableCell>{item.lotIsActive ? "Да" : "Нет"}</TableCell>
                      <TableCell>{item.active ? "Да" : "Нет"}</TableCell> */}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      Нет данных
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Paging
            localPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </>
      )}

      <ChangeLotStatusModal
        open={modalOpen}
        onClose={handleClose}
        lotId={selectedId}
        currentType={selectedType}
        onSuccess={handleSuccess}
      />
    </Box>
  );
};

export default LotStatusTable;
